import { GGeocoderRequest, GGeocoderResult } from "./types";

export const getGeoCode = async (request: GGeocoderRequest): Promise<GGeocoderResult[]> => {

    const geocoder = new window.google.maps.Geocoder();
    return new Promise<GGeocoderResult[]>( (resolve, reject) => {
        geocoder.geocode(request,  (results, status) => {
            if (status === "OK") {
                resolve(results || []);
            } else {
                reject(new Error(`Geocoding failed: ${status}`));
            }
        });
    });
}


export const getLatLng = (result: GGeocoderResult) => {
  const { lat, lng } = result.geometry.location;
  return {
    lat: lat(),
    lng: lng()
  };
};